import React, { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import SessionExpiredModal from '../../utils/SessionExpiredModal';
import UpdateCompanyDetailsModal from './UpdateCompanyDetailsModal';
import { Button } from '@mui/material';

function CompanySetting() {
  const [
    name,
    setName,
  ] = useState('');

  const [
    abn,
    setABN,
  ] = useState('');

  const navigate = useNavigate();

  const [
    isLoading,
    setIsLoading,
  ] = useState(true);

  const [
    updateModalShow,
    setUpdateModalShow,
  ] = useState(false);

  const [
    sessionExpired,
    setSessionExpired,
  ] = useState(false);

  const [
    taxAgentNumber,
    setTaxAgentNumber,
  ] = useState('123 456 789');

  const auth = useAuth();

  const fetchData = () => {
    if (auth.user?.profile.accountant.ssid) {
      console.log('execute');
      fetch(`${window.origin}/api/company`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.user?.access_token}`,
        },
      }).then((response) => {
        if (response.status === 403) {
          setSessionExpired(true);
          throw new Error('Session expired');
        }
        return response.json();
      }).then((data) => {
        setName(data.name);
        setABN(data.abn);
        setTaxAgentNumber(data.tan);
        setIsLoading(false);
      }).catch((error) => {
        console.error('Failed to fetch workers:', error);
      });
    }
  };

  useEffect(() => {
    console.log(auth.user?.profile.accountant.ssid);
    fetchData();
  }, [auth.user?.profile.accountant.ssid]);

  return (
    <div style={{ padding: '0 2.5vw' }}>
      <SessionExpiredModal show={sessionExpired} />
      <p style={{ fontSize: '0.8vw', color: 'rgb(0, 15, 30, 0.6)', fontWeight: '300', textAlign: 'center', marginBottom: '2vw' }}>
        Adjust company details and operational preferences
      </p>

      <div style={{ color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.9vw', marginTop: '2vw', backgroundColor: 'rgb(254, 254, 255, 0.6)', borderRadius: '1vw' }}>
        <div style={{ display: 'flex', flexDirection: 'row', padding: '1vw 1.5vw', borderBottom: '1px solid rgb(0, 15, 30, 0.05)' }}>
          <div style={{ flex: 1, fontWeight: '600' }}>
            <p style={{ margin: 0 }}>Company Name</p>
          </div>
          <div style={{ flex: 1 }}>
            <p style={{ textAlign: 'right', margin: 0 }}>{name}</p>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', padding: '1vw 1.5vw', borderBottom: '1px solid rgb(0, 15, 30, 0.05)' }}>
          <div style={{ flex: 1, fontWeight: '600' }}>
            <p style={{ margin: 0 }}>Australian Business Number</p>
          </div>
          <div style={{ flex: 1 }}>
            <p style={{ textAlign: 'right', margin: 0 }}>{abn}</p>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', padding: '1vw 1.5vw' }}>
          <div style={{ flex: 1, fontWeight: '600' }}>
            <p style={{ margin: 0 }}>Tax Agent Number</p>
          </div>
          <div style={{ flex: 1 }}>
            <p style={{ textAlign: 'right', margin: 0 }}>{taxAgentNumber}</p>
          </div>
        </div>
      </div>
      <div style={{ textAlign: 'center', marginTop: '1vw' }}>
        <Button
          onClick={() => { setUpdateModalShow(true); }}
          variant="outlined"
          style={{
            borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.4vw 1vw', marginBottom: '1vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '0.9vw', fontWeight: 500, letterSpacing: '0.08vw',
            marginTop: '1vw' }}
        >
          Update
        </Button>

      </div>
      <UpdateCompanyDetailsModal fetchData={fetchData} show={updateModalShow} onHide={() => setUpdateModalShow(false)} abn={abn} name={name} taxAgentNumber={taxAgentNumber} />
    </div>

  );
}

export default CompanySetting;
